import {
  Dialog,
  Box
} from '@mui/material';
import DeleteSvg from '../../../v3/Illustrration/components/DeleteSvg';
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper';
import { CustomButton } from '../../../v2/MUI_custom_component';

const ExitModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  title = "Are you sure you want to exit?",
  subtitle = "This action cannot be undone. All data would be lost?",
  confirmLabel = "Yes",
  cancelLabel = "No"
}) => {
  const handleCancelClick = () => {
    onClose();
  };

  const handleDeleteClick = () => {
    onConfirm();
  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
          sx: { borderRadius: 2, textAlign: 'center',  width: 400, p: 2 , m: 0, gap: 4}
      }}
    >
      <Box sx={{ textAlign: 'center'}}>
          <IllustrationWrapper 
            illustration={<DeleteSvg />}
            title={title}
            subtitle={subtitle}
          />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <CustomButton
            variant="filled"
            color="primary"
            label={cancelLabel}
            onClick={handleCancelClick}
            sx={{ width: '100%' }}
          />
          <CustomButton
            variant="outlined"
            color="primary"
            label={confirmLabel}
            onClick={handleDeleteClick}
            disabled={loading}
            loading={loading}
            sx={{ width: '100%' }}
          />
      </Box>
    </Dialog>
  );
};

export default ExitModal;
